import { roundToTwoDecimals } from "../utils/number_utils";

export default class SalesInvoice {
  set discountType(_discountType) {
    this._discountType = _discountType;
  }

  set discountValue(_discountValue) {
    this._discountValue = _discountValue;
  }

  netTotalBeforeDiscount(lines) {
    const { linesNetTotal } = this._computeLineData(lines);
    return roundToTwoDecimals(linesNetTotal);
  }

  netTotalAfterDiscount(netTotalBeforeDiscount) {
    let totalAfterDiscount = netTotalBeforeDiscount;
    if (this._discountValue) {
      if (this._discountType === "percentage") {
        totalAfterDiscount = (1 - this._discountValue / 100) * netTotalBeforeDiscount;
      } else {
        totalAfterDiscount = netTotalBeforeDiscount - this._discountValue;
      }
    }
    return roundToTwoDecimals(totalAfterDiscount);
  }

  vatTotal(lines) {
    const { vatAmount, linesNetTotal } = this._computeLineData(lines);

    return roundToTwoDecimals(vatAmount * (1 - this._globalDiscountRatio(linesNetTotal)));
  }

  grossTotal(lines) {
    const totalBeforeDiscount = this.netTotalBeforeDiscount(lines);
    const totalAfterDiscount = this.netTotalAfterDiscount(totalBeforeDiscount);
    const vatTotal = this.vatTotal(lines);

    return roundToTwoDecimals(totalAfterDiscount + vatTotal);
  }

  _globalDiscountRatio(linesNetTotal) {
    const isValidDiscount = this._discountValue && linesNetTotal !== 0;
    const isPercentageDiscount = this._discountType === "percentage";

    if (isValidDiscount && isPercentageDiscount) {
      return this._discountValue / 100;
    }

    if (isValidDiscount) {
      return this._discountValue / linesNetTotal;
    }

    return 0;
  }

  _computeLineData(lines) {
    const linesNetTotal = lines.reduce((sum, line) => sum + line.netTotal(), 0);
    const vatAmount = this._vatAmount(lines);

    return { vatAmount, linesNetTotal };
  }

  _vatAmount(lines) {
    const vatAmountByRate = lines.reduce((acc, line) => {
      acc[line._vatRate] ||= 0;
      acc[line._vatRate] += line.netTotal() * line._vatRate;
      return acc;
    }, {});

    const vatAmounts = Object.values(vatAmountByRate);
    return vatAmounts.reduce((sum, vatAmount) => sum + roundToTwoDecimals(vatAmount), 0);
  }
}
